export const baseFontSize = 16;

export const getFontSize = relative => `${relative}em`;

export const getLineHeight = relative =>`${relative}em`;

export default {
  baseFontSize,
  getFontSize,
  getLineHeight,
};



// WEBPACK FOOTER //
// ./src/styles/font.js